var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14","viewBox":"0 0 14 14"}},[_c('path',{staticClass:"a",class:{red: _vm.red, gray: _vm.gray},attrs:{"d":"M7,0l7,14H0Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }